
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { LoginService } from '../../login/login.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Capability } from '../../common/_types/capability';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { Country } from '../../common/_types/country';
import { Rate } from '../_types/rate';
import { RatesService } from '../_services/rates.service';
import { RateLine } from '../_types/rate-line';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { RateLinesService } from '../_services/rates-lines.service';
import { RateLineComponent } from './rate-line/rate-line.component';
import { DialogService } from 'primeng/dynamicdialog';
import { Company } from '../../companies/_types/company';
import { CompanyRatesService } from '../../companies/_services/companies-rates.service';
import { CompanyRate } from '../../companies/_types/company-rate';
import { RateCompanyComponent } from './rate-company/rate-company.component';

import { RateUploadExcelComponent } from './rate-upload-excel/rate-upload-excel.component';
import { RateTemplate } from '../_types/rate-template';
import { RatesTemplatesService } from '../_services/rates-templates.service';
import { RateTemplateComponent } from './rate-template/rate-template.component';
import { WorkerRate } from '../_types/worker-rate';
import { WorkerRatesService } from '../_services/workers-rates.service';
import { RateWorkerComponent } from './rate-worker/rate-worker.component';
import { ProviderRate } from '../_types/provider-rate';
import { ProviderRatesService } from '../_services/providers-rates.service';
import { RateProviderComponent } from './rate-provider/rate-provider.component';

@Component({
    selector: 'app-rates-detail',
    templateUrl: './rates-detail.component.html',
    styleUrls: ['./rates-detail.component.css'],
    standalone: false
})
export class RatesDetailComponent implements OnInit {

  public rateFormGroup!: RxFormGroup;

  public rate: Rate = new Rate();
  public totalRecords: number = 0;
  public loading: boolean = false;
  public activeIndex: number = 1;
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allowWriteTemplate: boolean = false;
  public allowDeleteTemplate: boolean = false;

  public selectedCapabilities: any[] = [];

  public capabilities: Array<Capability> = new Array<Capability>();
  public required: boolean = true;

  public rateLines: RateLine[] = [];
  public loadingRateLines: boolean = false;
  public totalRateLinesRecords: number = 0;
  public rateLinesCapabilities: any[] = [];
  public rateTemplates: RateTemplate[] = [];
  public companies: CompanyRate[] = [];
  public workers: WorkerRate[] = [];
  public providers: ProviderRate[] = [];
  public totalCompaniesRecords: number = 0;
  public totalWorkersRecords: number = 0;
  public totalProvidersRecords: number = 0;
  public totalRateTemplatesRecords: number = 0;
  public type: string = "";

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private ratesService: RatesService,
    private rateLinesService: RateLinesService,
    private dialogService: DialogService,
    private companyRatesServices: CompanyRatesService,
    private workerRatesServices: WorkerRatesService,
    private ratesTemplatesService: RatesTemplatesService,
    private providerRatesService: ProviderRatesService
  ) {



  }

  ngOnInit(): void {
    let title = "Baremos";
    this.route.paramMap.subscribe((params: ParamMap) => {
      let id: string | null = params.get('id');
      this.type = params.get('type') ?? '';
       if(this.type=="COMPANY"){
        title="compañía";
      }else if(this.type=="WORKER"){
        title="operador";
      }else if(this.type == "PROVIDER"){
        title="proveedor";
      }else{
        title="Baremos";
      }

      this.topbarService.setTitle("Detalles de baremo de " + title);
      this.topbarService.addBreadcrumb("Baremos de " + title, "/rates/" + this.type);
      this.rate.typeOfRate = this.type;
      this.rateFormGroup = this.formBuilder.formGroup<Rate>(this.rate) as RxFormGroup;
      if (id != null && id != '0') {
        this.loadRate(id);
      }

    });
    this.allowWrite = this.loginService.hasPermission(this.type + "_RATES.WRITE");
    this.allowDelete = this.loginService.hasPermission(this.type + "_RATES.DELETE");
    this.allowWriteTemplate = this.loginService.hasPermission(this.type + "_RATES.TEMPLATES_WRITE");
    this.allowDeleteTemplate = this.loginService.hasPermission(this.type + "_RATES.TEMPLATES_DELETE");

  }

  async loadRate(id: string) {
    this.rate = await firstValueFrom(this.ratesService.get(id));
    this.rateFormGroup.patchValue(this.rate);
    this.loadRateLines();
    this.loadRateTemplates();
    if (this.type == "COMPANY") this.loadCompanies();
    if (this.type == "WORKER") this.loadWorkers();
    if (this.type == "PROVIDER") this.loadProviders();

  }

  async loadRateLines() {
    this.loadingRateLines = true;
    let params: IParamsCollection = {
      sort: ['code'],
      page: {
        size: 10000,
        number: 0
      },
    }
    let filters: any = {
      rateId: new Filter(FilterOperation.equals, "rateId"),
    };

    filters.rateId.value = this.rate.id;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['capability'];

    let response = await firstValueFrom(this.rateLinesService.all(params));
    this.rateLines = response.data;
    this.rateLinesCapabilities = [];
    this.rateLines.forEach((rateLine: RateLine) => {
      this.rateLinesCapabilities.push({
        id: rateLine.capabilityId,
        name: rateLine.capability?.name
      });
    });
    // quitar duplicados
    this.rateLinesCapabilities = this.rateLinesCapabilities.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);

  }

  async loadRateTemplates() {
    let params: IParamsCollection = {};

    let filters: any = {
      rateId: new Filter(FilterOperation.equals, "rateId"),
    };

    filters.rateId.value = this.rate.id;
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.ratesTemplatesService.all(params));
    this.rateTemplates = response.data;
    this.totalRateTemplatesRecords = response.meta['total'];
  }

  rateLinesByCapability(capabilityId: string) {
    return this.rateLines.filter((rateLine: RateLine) => rateLine.capabilityId == capabilityId);
  }


  async loadCompanies() {
    let filters = {
      rateId: new Filter(FilterOperation.equals, 'rateId', "", this.rate.id)
    };

    let params: IParamsCollection = {
      include: ['company', 'contract', 'insuranceCompany']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.companyRatesServices.all(params));

    this.companies = response.data;
  }

  async loadWorkers() {
    let filters = {
      rateId: new Filter(FilterOperation.equals, 'rateId', "", this.rate.id)
    };

    let params: IParamsCollection = {
      include: ['worker']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerRatesServices.all(params));

    this.workers = response.data;
  }


  async loadProviders() {
    let filters = {
      rateId: new Filter(FilterOperation.equals, 'rateId', "", this.rate.id)
    };

    let params: IParamsCollection = {
      include: ['provider']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.providerRatesService.all(params));

    this.providers = response.data;
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.rateFormGroup);
    if (valid) {

      this.rate = Object.assign(this.rate, this.rateFormGroup.value);

      let rate = await firstValueFrom(this.ratesService.save(this.rate));

      /*if(typeof this.rate.id != "undefined" && this.rate.id != ""){
        await firstValueFrom(this.ratesService.updateCapabilities(this.rate.id!, this.selectedCapabilities));
      }*/

      this.messageService.add({ closable: true, severity: 'success', summary: "Baremo guardado correctamente." });

      if (this.rate.id != "undefined" && this.rate.id != "") {
        this.router.navigate(['rates/' + this.type]);
      }
      this.loadRate(rate.id!);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el baremo?",
      header: "Eliminar baremo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.ratesService.delete(this.rate.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Baremo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['rates/' + this.type]);
  }

  async editRateLine(rateLine: RateLine | null) {
    let ref = this.dialogService.open(RateLineComponent, {
      closable: true,
      modal: true,
      header: 'Ficha de línea de baremo',
      width: '50%',
      data: {
        rateId: this.rate.id,
        rateLineId: rateLine ? rateLine.id : null
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadRateLines();
    });
  }

  async deleteRateLine(id: string) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la línea de baremo?",
      header: "Eliminar línea",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.rateLinesService.delete(id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Línea eliminada correctamente." });
            this.loadRateLines();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }


  addCompany(rateCompany: any) {
    const ref = this.dialogService.open(RateCompanyComponent, {
      closable: true,
      modal: true,
      data: {
        rateCompanyId: rateCompany.id,
        rateId: this.rate.id
      },
      header: "Asignar compañía",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadCompanies();
    });
  }

  deleteCompany(rateCompany: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar la compañía " + rateCompany.company?.name + "?",
      header: "Desasignar compañía",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.companyRatesServices.delete(rateCompany.id).subscribe({
          next: (data: any) => {
            this.loadCompanies();
            this.messageService.add({ closable: true, severity: 'success', detail: "Compañía desasignada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  addWorker(workerRate: any) {
    const ref = this.dialogService.open(RateWorkerComponent, {
      closable: true,
      modal: true,
      data: {
        workerRateId: workerRate.id,
        rateId: this.rate.id
      },
      header: "Asignar operario",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadWorkers();
    });
  }

  deleteWorker(workerRate: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el operario " + workerRate.worker?.name + "?",
      header: "Desasignar operario",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerRatesServices.delete(workerRate.id).subscribe({
          next: (data: any) => {
            this.loadWorkers();
            this.messageService.add({ closable: true, severity: 'success', detail: "Operario desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  addProvider(providerRate: any) {
    const ref = this.dialogService.open(RateProviderComponent, {
      closable: true,
      modal: true,
      data: {
        providerRateId: providerRate.id,
        rateId: this.rate.id
      },
      header: "Asignar proveedor",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadProviders();
    });
  }

  deleteProvider(providerRate: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el proveedor " + providerRate.provider?.name + "?",
      header: "Desasignar proveedor",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.providerRatesService.delete(providerRate.id).subscribe({
          next: (data: any) => {
            this.loadProviders();
            this.messageService.add({ closable: true, severity: 'success', detail: "Proveedor desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  editRateTemplate(rateTemplate: RateTemplate | null) {
    if(this.allowWriteTemplate){
      let ref = this.dialogService.open(RateTemplateComponent, {
        closable: true,
        modal: true,
        header: 'Plantilla de baremo',
        width: '50%',
        data: {
          rateId: this.rate.id,
          rateTemplateId: rateTemplate ? rateTemplate.id : null,
          type: this.type
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadRateTemplates();
      });
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "No tiene permisos para editar plantillas de baremo." });
    }
  }

  deleteRateTemplate(rateTemplate: RateTemplate) {
    if(this.allowDeleteTemplate){
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la plantilla de baremo?",
        header: "Eliminar plantilla de baremo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.ratesTemplatesService.delete(rateTemplate.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Plantilla de baremo eliminada correctamente." });
              this.loadRateTemplates();
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "No tiene permisos para eliminar plantillas de baremo." });
    }
  }

  loadExcel() {
    const ref = this.dialogService.open(RateUploadExcelComponent, {
      closable: true,
      modal: true,
      data: {
        rateId: this.rate.id
      },
      header: "Importar Excel",
      width: '600px'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadRateLines();
    });

  }

  downloadExcel() {

    // Hacer la petición al backend para obtener el archivo Excel
    let filename = this.rate.name;
    this.ratesService.downloadExcel(this.rate.id!, filename);
  }

}
